import { Component, OnInit, TemplateRef, ViewChild, Renderer2, ElementRef, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';
import { iif, Observable } from 'rxjs';
import { formatDate, DatePipe } from '@angular/common';
import * as firebase from 'firebase/';
import { MatStepper } from '@angular/material/stepper';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import LocationPicker from "location-picker";
import { PDFSource } from 'ng2-pdf-viewer';
import { MatDialog } from '@angular/material/dialog';


import { environment } from '../../../environments/environment'
import { functions } from '../../Helpers/functions'
import { alerts } from '../../Helpers/alerts'
import { data } from '../ficha/data/unidadesEducativas';
import { dataNivel } from '../ficha/data/niveles';
import { Router } from '@angular/router';


export class Location {
  lat: number;
  lng: number;
  name?: string;
  zoom?: number;
  icon?: string;
}
@Component({
  selector: 'app-mapa',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.css']
})
export class MapaComponent implements OnInit {
  DatosServicioTransporteFormGroup: UntypedFormGroup;
  constructor(private renderer: Renderer2, private _formBuilder: UntypedFormBuilder, public db: AngularFireDatabase, public datePipe: DatePipe, private dialog: MatDialog, private router: Router) { }


  @Input() tipoServicio: any;

  latitudRecoijida;
  longitudRecojida;

  latitudDeja;
  longitudDeja;

  formSubmittedServicio = false;
  ngOnInit(): void {
    console.log("mapa")
    console.log(this.tipoServicio)

    this.latitudRecoijida = -0.172216
    this.longitudRecojida = -78.460953

    this.latitudDeja = -0.172216
    this.longitudDeja = -78.460953

    this.DatosServicioTransporteFormGroup = this._formBuilder.group({
      TipoServicioTransporte: ['', Validators.compose([Validators.required])],
      DireccionExacta: ['', Validators.compose([Validators.required, Validators.pattern('[-\\a-zA-ZáéíóúñÁÉÍÓÚÑ0-9 ]*')])],
      DireccionExactaRetorno: [''],

    });

  }





  get TipoServicioTransporte() { return this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte }
  get DireccionExacta() { return this.DatosServicioTransporteFormGroup.controls.DireccionExacta }
  get DireccionExactaRetorno() { return this.DatosServicioTransporteFormGroup.controls.DireccionExactaRetorno }











  helperMap() {
    alerts.informationmapHelp();
  }



  direccionRetornoP = false;


  public locationDireccion: Location;
  public locationDireccionRegreso: Location;

  locationDireccionChange(location: Location) {
    this.locationDireccion = location;

    this.latitudRecoijida = location["lat"]
    this.longitudRecojida = location["lng"]
    console.log(location["lat"]);
    console.log(location["lng"]);/**/
    //   this.DatosServicioTransporteFormGroup.controls['CoordenadasForm'].setErrors({ 'incorrect': false });
    //   this.DatosServicioTransporteFormGroup.get('CoordenadasForm').setValue(JSON.stringify(location));
  }

  locationDireccionRetornoChange(location: Location) {
    this.locationDireccionRegreso = location;

    this.latitudDeja = location["lat"]
    this.longitudDeja = location["lng"]

  }

  DatosServicioTransporteFormGrou:any

  public tieneRetorno: Boolean;

  cambioTipoServicio() {
    if (this.DatosServicioTransporteFormGroup.controls.TipoServicioTransporte.value == 'DOBLE RUTA') {
      this.tieneRetorno = true;
    } else {
      this.tieneRetorno = false;
      this.locationDireccionRegreso = null;
    }
  }




  invalidField(field: string) {
    return functions.invalidFields(field, this.DatosServicioTransporteFormGroup, this.formSubmittedServicio);
  }

}



